<template>
  <div id="rawfileData" class="animated fadeIn h-100">
    <div id="Loader" v-if="LoadYn">
      <div class="spinner-bar">
        <span></span>
        <span></span>
        <span></span>
        <span></span>
      </div>
    </div>
    <div>
      <b-card class="h-100 m5 default-border1" body-class="h-100 p-0">
        <div class="searchBox">
          <div>
            <label>프로젝트</label>
            <vue-select
              class="select-container w200"
              v-model="search.projectid"
              :options="search.projectOptions"
              @input="getStidList"
              :reduce="(a) => a.value"
              label="text"
              :clearable="false"
              required
            >
            </vue-select>
            <label>구조물</label>
            <vue-select
              class="select-container w200"
              v-model="search.stid"
              :options="search.stidOptions"
              @input="getDeviceList"
              :reduce="(a) => a.value"
              label="text"
              :clearable="false"
              required
            >
            </vue-select>
            <label>디바이스</label>
            <b-form-select
              class="w200"
              v-model="search.deviceid"
              :options="search.deviceOptions"
              required
            ></b-form-select>
            <label>기간</label>
            <b-form-input
              type="date"
              class="w200"
              v-model="search.stdate"
              required
            ></b-form-input>
            <label>~</label>
            <b-form-input
              type="date"
              class="w200"
              v-model="search.eddate"
              required
            ></b-form-input>
          </div>
          <div>
            <b-button class="searchBtn" @click="getData">조회</b-button>
          </div>
        </div>
      </b-card>
    </div>
    <div>
      <b-row class="h400">
        <b-col class="col-4">
          <b-card
            class="h390 m5 default-border1"
            body-class="h-100 p-0"
            header-tag="header"
          >
            <h6 slot="header">일별 RAWFILE 현황</h6>
            <div
              id="rawfileCntChart"
              class="h345 w-100 default-border-top1"
            ></div>
          </b-card>
        </b-col>
        <b-col class="col-8">
          <b-card
            class="h390 m5 default-border1"
            body-class="h-100 p-0"
            header-tag="header"
          >
            <h6 slot="header">시간별 RAWFILE 현황</h6>
            <div id="rawfileChart2" class="h345 default-border-top1"></div>
          </b-card>
        </b-col>
      </b-row>
    </div>
    <div class="hc-sub460">
      <b-card
        class="h-100 m5 default-border1"
        body-class="h-100 p-0"
        header-tag="header"
      >
        <h6 slot="header">RAWFILE 목록</h6>
        <ag-grid-vue
          class="ag-theme-balham"
          :gridOptions="rawfileGridOptions"
        ></ag-grid-vue>
      </b-card>
    </div>
    <b-modal
      id="rawfileChartModal"
      :title="modalTitle"
      title-tag="h5"
      header-class="jcc"
      centered
      hide-footer
      no-close-on-backdrop
      no-close-on-esc
      hide-header-close
    >
      <rawfile-chart-modal :chartInfo="chartInfo"></rawfile-chart-modal>
    </b-modal>
    <div v-show="isShowFloatingBtn" class="floatingBtn">
      <div>
        <b-button
          class="btn btn-primary"
          @click="onClickFloatingBtn"
          v-b-tooltip.hover
          title="선택 파일 다운로드"
        >
          <i class="fas fa-download"></i>
        </b-button>
      </div>
    </div>
    <b-modal
      id="multipleDownloadProgress"
      title="Rawfile 다운로드"
      title-tag="h5"
      header-class="jcc"
      centered
      no-close-on-backdrop
      no-close-on-esc
      hide-header-close
    >
      <b-container>
        <div class="content">
          <div class="left">
            <label>{{ progress.current }}</label>
            <label>/</label>
            <label>{{ progress.total }}</label>
          </div>
          <b-progress
            :value="progress.current"
            :max="progress.total"
            animated
          ></b-progress>
        </div>
        <div class="files">
          <div v-for="file in progress.files" :key="file.name" class="file">
            <label>{{ file.name }}</label>
            <i
              :class="
                file.state === 'success'
                  ? 'fas fa-check'
                  : file.state === 'failure'
                  ? 'fas fa-times'
                  : 'fas fa-ellipsis-h'
              "
              :style="
                file.state === 'success'
                  ? 'color: #28c762'
                  : file.state === 'failure'
                  ? 'color: red'
                  : 'color: white'
              "
            ></i>
          </div>
        </div>
      </b-container>
      <template #modal-footer>
        <b-button @click="$bvModal.hide('multipleDownloadProgress')"
          ><i class="fa fa-window-close"></i>
          닫기
        </b-button>
      </template>
    </b-modal>
  </div>
</template>
<script>
import { AgGridVue } from "ag-grid-vue";
import { mapGetters, mapMutations } from "vuex";
import moment from "moment";
import utils from "../common/utils";
import chartUtil from "../common/chartUtil";
import btnRenderer from "../common/cellBtnRenderer";
import RawfileChartModal from "./RawfileChartModal.vue";
import VueSelect from "vue-select";
import "vue-select/dist/vue-select.css";

var Plotly = require("plotly.js/dist/plotly.min.js");

export default {
  components: {
    AgGridVue,
    RawfileChartModal,
    VueSelect,
  },
  computed: {
    ...mapGetters([
      "getUserId",
      "getUserAuth",
      "getCenterBus",
      "getAlertOptions",
      "getConfirmOptions",
      "getSelectedDataProjectid",
      "getSelectedDataStid",
      "getSelectedDataStartDate",
      "getSelectedDataEndDate",
    ]),
  },
  watch: {
    "search.stid"(param) {
      if (!param) {
        this.search.deviceid = null;
        this.search.deviceOptions = [{ value: null, text: "선택" }];
      }
    },
  },
  data() {
    return {
      search: {
        projectid: null,
        stid: null,
        deviceid: null,
        projectOptions: [{ value: null, text: "선택" }],
        stidOptions: [{ value: null, text: "선택" }],
        deviceOptions: [{ value: null, text: "선택" }],
        stdate: null,
        eddate: null,
      },
      rawfileGridOptions: {
        columnDefs: null,
        rowData: [],
        localeText: { noRowsToShow: "조회 결과가 없습니다." },
        onGridReady: (params) => {
          params.api.sizeColumnsToFit();
        },
        rowSelection: "multiple",
        toolPanelSuppressSideButtons: true,
        rowHeight: 35,
        headerHeight: 35,
        enableSorting: true,
        enableColResize: true,
        suppressHorizontalScroll: true,
        onSelectionChanged: (event) => {
          let selectedRows = event.api.getSelectedRows();
          if (selectedRows.length > 1) {
            this.selectedRow = selectedRows[0];
            this.isShowFloatingBtn = true;
          } else {
            this.isShowFloatingBtn = false;
          }
        },
      },
      LoadYn: false,
      modalTitle: "",
      chartInfo: null,
      isFirstCall: true,
      isShowFloatingBtn: false,
      progress: {
        current: 0,
        total: 0,
        files: [],
      },
    };
  },
  created() {
    this.getProjectList();
    this.search.stdate = moment().subtract(7, "days").format("YYYY-MM-DD");
    this.search.eddate = moment().format("YYYY-MM-DD");
  },
  beforeMount() {
    this.rawfileGridOptions.columnDefs = [
      {
        headerName: "선택",
        field: "select",
        headerCheckboxSelection: true,
        checkboxSelection: true,
        width: 100,
      },
      { headerName: "시간", field: "time" },
      { headerName: "파일이름", field: "filename" },
      { headerName: "사이즈(Byte)", field: "filesize" },
      {
        headerName: "차트",
        field: "showRawfile",
        cellRendererFramework: btnRenderer,
        cellRendererParams: {
          evtBus: this.getCenterBus,
          emitEvtName: "showRawfile",
          btnText: null,
          iconYn: true,
          iconClass: "fas fa-poll",
          backgroundColor: "#ff8c00",
          borderColor: "#ff8c00",
          color: "#fff",
        },
      },
      {
        headerName: "다운로드",
        field: "filedownload",
        cellRendererFramework: btnRenderer,
        cellRendererParams: {
          evtBus: this.getCenterBus,
          emitEvtName: "rawfileDownload",
          btnText: null,
          iconYn: true,
          iconClass: "fas fa-download",
          backgroundColor: "#207245",
          borderColor: "#207245",
          color: "#fff",
        },
      },
    ];
  },
  mounted() {
    this.getCenterBus.$on("rawfileDownload", (param) => {
      this.rawfileDownload(param);
    });
    this.getCenterBus.$on("showRawfile", (param) => {
      this.openRawfileCahrt(param);
    });
    if (this.getSelectedDataStartDate)
      this.search.stdate = this.getSelectedDataStartDate;
    if (this.getSelectedDataEndDate)
      this.search.eddate = this.getSelectedDataEndDate;
  },
  destroyed() {
    this.getCenterBus.$off("rawfileDownload");
    this.getCenterBus.$off("showRawfile");
  },
  methods: {
    ...mapMutations([
      "setAlertTitle",
      "setConfirmTitle",
      "setSelectedDataProjectid",
      "setSelectedDataStid",
      "setSelectedDataStartDate",
      "setSelectedDataEndDate",
    ]),
    getProjectList() {
      let reqBody = {};
      this.$http
        .post("/stat/getProjectList", reqBody)
        .then((res) => {
          if (res.data.resultyn === "Y") {
            let data = res.data.data;
            let options = [{ value: null, text: "선택" }];
            for (let i = 0; i < data.length; i++) {
              options.push({
                value: data[i].projectid,
                text: data[i].projectname,
              });
            }
            this.search.projectOptions = options;
            if (this.getSelectedDataProjectid) {
              this.search.projectid = this.getSelectedDataProjectid;
              this.getStidList();
            } else this.search.projectid = null;
          } else {
            this.setAlertTitle("프로젝트 조회 실패");
            this.$bvModal
              .msgBoxOk("관리자에게 문의하세요.", this.getAlertOptions)
              .then((value) => {})
              .catch((err) => {
                console.error(err);
              });
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },
    getStidList() {
      if (!this.search.projectid) {
        this.search.stidOptions = [{ value: null, text: "선택" }];
        this.search.stid = null;
        return;
      }
      var reqBody = {
        projectid: this.search.projectid,
      };
      this.$http
        .post("/sensor/getStidList", reqBody)
        .then((res) => {
          if (res.data.resultyn === "Y") {
            let data = res.data.data;
            let options = [{ value: null, text: "선택" }];
            for (let i = 0; i < data.length; i++) {
              if (data[i].projectid === this.search.projectid) {
                options.push({
                  value: data[i].stid,
                  text: data[i].stname,
                });
              } else {
                continue;
              }
            }
            this.search.stidOptions = options;
            if (this.isFirstCall) {
              if (this.getSelectedDataStid) {
                this.search.stid = this.getSelectedDataStid;
                this.getDeviceList();
              } else this.search.stid = null;
            } else this.search.stid = null;
            this.isFirstCall = false;
          } else {
            this.setAlertTitle("구조물 조회 실패");
            this.$bvModal
              .msgBoxOk("관리자에게 문의하세요.", this.getAlertOptions)
              .then((value) => {})
              .catch((err) => {
                console.error(err);
              });
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },
    getDeviceList() {
      if (!this.search.stid) {
        this.search.deviceOptions = [{ value: null, text: "선택" }];
        this.search.deviceid = null;
        return;
      }
      let reqBody = {
        projectid: this.search.projectid,
        stid: this.search.stid,
      };
      this.$http
        .post("/device/getDeviceList", reqBody)
        .then((res) => {
          if (res.data.resultyn === "Y") {
            let devicelist = res.data.data.deviceList;
            let options = [{ value: null, text: "선택" }];
            for (let i = 0; i < devicelist.length; i++) {
              options.push({
                value: devicelist[i].deviceid,
                text: devicelist[i].devicename,
              });
            }
            this.search.deviceOptions = options;
            this.search.deviceid = null;
          } else {
            this.setAlertTitle("디바이스 목록 조회 실패");
            this.$bvModal
              .msgBoxOk("관리자에게 문의하세요.", this.getAlertOptions)
              .then((value) => {})
              .catch((err) => {
                console.error(err);
              });
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },
    // HICC230609
    checkFilter(item, itemname) {
      if (item === null) {
        this.setAlertTitle("필수 입력 항목 누락");
        this.$bvModal
          .msgBoxOk(itemname + " 선택하세요.", this.getAlertOptions)
          .then((value) => {})
          .catch((err) => {
            console.error(err);
          });
        return false;
      }
      return true;
    },
    getData() {
      // HICC230609
      if (!this.checkFilter(this.search.projectid, "프로젝트를")) return;
      if (!this.checkFilter(this.search.stid, "구조물을")) return;
      if (!this.checkFilter(this.search.deviceid, "디바이스를")) return;

      let YYYYMMDDHH = 10;
      let YYYYMMDDHHMM = 12;
      let reqBody = {
        device_id: this.search.deviceid,
        st_time: moment(this.search.stdate).format("YYYYMMDD"),
        ed_time: moment(this.search.eddate).format("YYYYMMDD"),
      };
      this.setSelectedDataProjectid(this.search.projectid);
      this.setSelectedDataStid(this.search.stid);
      this.setSelectedDataStartDate(this.search.stdate);
      this.setSelectedDataEndDate(this.search.eddate);

      this.LoadYn = true;
      this.$http
        .post("/sensor/getRawfileList", reqBody, { timeout: 600000 })
        .then((res) => {
          if (res.data.resultyn === "Y") {
            this.LoadYn = false;
            let fileCnt = res.data.data.date_file_cnt;
            let data = res.data.data.file;
            let rowData = [];
            let chartData2 = { x: [], y: [] };
            for (let i = 0; i < data.length; i++) {
              rowData.push({
                time: data[i][1],
                filename: data[i][2],
                filesize: data[i][3]
                  .toString()
                  .replace(/\B(?=(\d{3})+(?!\d))/g, ","),
              });
              if (data[i][1].length === YYYYMMDDHH) {
                chartData2.x.push(
                  (data[i][1] + "00").replace(
                    /^(\d{4})(\d\d)(\d\d)(\d\d)(\d\d)$/,
                    "$1-$2-$3 $4:$5"
                  )
                );
              } else if (data[i][1].length === YYYYMMDDHHMM) {
                chartData2.x.push(
                  data[i][1].replace(
                    /^(\d{4})(\d\d)(\d\d)(\d\d)(\d\d)$/,
                    "$1-$2-$3 $4:$5"
                  )
                );
              } else {
                // 8
                // pass
              }
              chartData2.y.push(data[i][3]);
            }
            this.rawfileGridOptions.api.setRowData(rowData);
            let chartData = { x: [], y: [] };
            for (let j = 0; j < fileCnt.length; j++) {
              chartData.x.push(
                fileCnt[j][0].substr(0, 4) +
                  "-" +
                  fileCnt[j][0].substr(4, 2) +
                  "-" +
                  fileCnt[j][0].substr(6, 2)
              );
              chartData.y.push(fileCnt[j][1]);
            }
            this.$nextTick(() => {
              this.drawDateBarChart("rawfileCntChart", {
                data: chartData,
                annotation: {
                  yaxis: {
                    text: "파일 개수",
                    x: -0.13,
                    y: 0.5,
                  },
                },
              });
              this.drawTimeBarChart("rawfileChart2", {
                data: chartData2,
                annotation: {
                  yaxis: {
                    text: "파일 크기",
                    x: -0.07,
                    y: 0.5,
                  },
                },
              });
            });
          } else {
            this.LoadYn = false;
            this.setAlertTitle("데이터 조회 실패");
            this.$bvModal
              .msgBoxOk(
                `${res.data.errormsg} 관리자에게 문의하세요.`,
                this.getAlertOptions
              )
              .then((value) => {})
              .catch((err) => {
                console.error(err);
              });
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },
    drawDateBarChart(id, param, range) {
      let data = [
        {
          x: param.data.x,
          y: param.data.y,
          type: "bar",
        },
      ];
      let layout = chartUtil.setLayout(id, {
        margin: {
          l:
            utils.chkNull(param.annotation) !== null &&
            utils.chkNull(param.annotation.yaxis) !== null
              ? 80
              : 50,
          r: 30,
          t: 30,
          b: 50,
          pad: 10,
        },
        annotation: param.annotation,
        showlegend: false,
      });
      layout.xaxis.tickformat = "%m-%d";
      Plotly.newPlot(id, data, layout, { scrollZoom: true });
    },
    drawTimeBarChart(id, param, range) {
      let data = [
        {
          x: param.data.x,
          y: param.data.y,
          type: "bar",
        },
      ];
      let layout = chartUtil.setTimeLayout(id, {
        margin: {
          l:
            utils.chkNull(param.annotation) !== null &&
            utils.chkNull(param.annotation.yaxis) !== null
              ? 90
              : 50,
          r: 30,
          t: 20,
          b: 50,
          pad: 10,
        },
        annotation: param.annotation,
        showlegend: false,
      });
      layout.xaxis.tickformat = "%m/%d %H:%M";
      // layout.xaxis.dtick = 86400000.0
      Plotly.newPlot(id, data, layout, { scrollZoom: true });
    },
    openRawfileCahrt(param) {
      this.modalTitle = param.filename;
      this.chartInfo = {
        filename: param.filename,
        dev_id: this.search.deviceid,
      };
      this.$bvModal.show("rawfileChartModal");
    },
    async rawfileDownload(param) {
      let result = await this.downloadRawfile(param.filename);
      if (!result) {
        this.setAlertTitle("파일 다운로드 실패");
        this.$bvModal
          .msgBoxOk("관리자에게 문의하세요.", this.getAlertOptions)
          .then((value) => {})
          .catch((err) => {
            console.error(err);
          });
      }
    },
    onClickFloatingBtn() {
      let selectedRows = this.rawfileGridOptions.api.getSelectedRows();
      let files = selectedRows.map((item) => item.filename);

      this.setConfirmTitle("여러 파일 다운로드 확인");
      let confirmMessage = `선택한 ${files[0]} 등 ${files.length}개 파일을 다운로드 하시겠습니까?`;
      this.$bvModal
        .msgBoxConfirm(confirmMessage, this.getConfirmOptions)
        .then((value) => {
          if (value) {
            this.downloadMultipleFiles(files);
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },
    initProgress() {
      this.progress.current = 0;
      this.progress.total = 0;
      this.progress.files = [];
    },
    async downloadMultipleFiles(files) {
      this.initProgress();
      this.$bvModal.show("multipleDownloadProgress");
      this.progress.total = files.length;
      this.progress.files = files.map((file) => {
        return { name: file, state: null };
      });

      for (let i = 0; i < files.length; i++) {
        this.progress.current = i + 1;
        try {
          let result = await this.downloadRawfile(files[i]);
          if (result) {
            this.progress.files[i].state = "success";
          } else {
            this.progress.files[i].state = "failure";
          }
        } catch (err) {
          console.error(err);
        }
      }
    },
    async downloadRawfile(file) {
      this.LoadYn = true;
      let csvFiles = await this.unzipRawfile(file);
      for (let i = 0; i < csvFiles.length; i++) {
        try {
          let fileName = extractNameFromPath(csvFiles[i].csv_file_path);
          let fileData = await this.getFileData(csvFiles[i].csv_file_path);
          this.downloadFile(fileData, fileName, "csv");
        } catch (err) {
          console.error(err);
          this.LoadYn = false;
          return false;
        }
      }
      this.LoadYn = false;
      return true;

      function extractNameFromPath(path) {
        return path.substring(path.lastIndexOf("/") + 1, path.lastIndexOf("."));
      }
    },
    async unzipRawfile(file) {
      let res = await this.$http.post(
        "/sensor/getRawFileData",
        { device_id: this.search.deviceid, file_name: file },
        { timeout: 160000 }
      );
      if (res.data.resultyn === "Y") {
        return res.data.data;
      } else {
        throw new Error(res.data.errormsg);
      }
    },
    async getFileData(path) {
      let res = await this.$http.post(
        "/sensor/csvFileDownload",
        { csvFilePath: path },
        { responseType: "arraybuffer", timeout: 20000 }
      );
      if (res) {
        return res;
      } else {
        throw new Error("No File");
      }
    },
    downloadFile(res, fileName, extension) {
      try {
        let blob = new Blob([res.data], { type: res.headers["content-type"] });
        fileName += extension ? "." + extension : ".xlsx";
        let tempTag = document.createElement("a");
        tempTag.id = "excelDown";
        tempTag.href = window.URL.createObjectURL(blob);
        tempTag.target = "_self";
        tempTag.style.display = "none";
        tempTag.download = fileName;
        tempTag.click();
        tempTag.remove();
      } catch (err) {
        console.error(err);
        throw new Error("File Download Error");
      }
    },
  },
};
</script>
<style scoped lang="scss">
#rawfileData {
  padding: 15px;
  .card {
    .card-body {
      padding: 0;
    }
  }
  & .searchBox {
    justify-content: space-between;
  }
  & div.ag-theme-balham {
    width: 100%;
    height: 100%;
  }
  .chartarea {
    height: 390px;
  }
  .graph {
    height: 335px;
  }
  .floatingBtn {
    position: fixed;
    bottom: 30px;
    right: 30px;
    button {
      border-radius: 30px;
      background-color: #207245;
      border: 0;
      color: white;
      width: 70px;
      height: 70px;
      i {
        font-size: 30px;
      }
    }
  }
}
/deep/ #multipleDownloadProgress > .modal-dialog {
  width: 700px;
  .container {
    padding: 15px;
    .content {
      display: flex;
      justify-content: center;
      .left {
        width: 15%;
        display: flex;
        label {
          margin: 5px;
          font-size: 25px;
        }
      }
      .progress {
        width: 85%;
        margin: 15px;
        border-radius: 10px;
      }
    }
    .files {
      height: 300px;
      overflow: auto;
      border: 1px solid #7367f0;
      margin-top: 15px;
      .file {
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        padding: 0 20px;
        label {
          width: calc(100% - 20px);
          font-size: 20px;
        }
        i {
          width: 20px;
          font-size: 20px;
        }
      }
      .file:nth-child(even) {
        background-color: rgb(12, 20, 48);
      }
    }
  }
  .modal-footer {
    justify-content: center;
    border-top: 1px solid #3b4253;
    button {
      height: 30px;
      color: #fff;
      border-color: #82868b;
      border-radius: 15px;
      line-height: 16.5px;
      padding: 6px 16px;
      background-color: #82868b;
      &:hover {
        background-color: #6f7378;
        border-color: #696d71;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/sensor/RawfileData.vue